import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { SignalType } from '../types';

interface SignalGaugeProps {
  signal: SignalType;
  confidence: number;
}

const SignalGauge: React.FC<SignalGaugeProps> = ({ signal, confidence }) => {
  
  // Determine color based on signal
  let color = '#94a3b8'; // Slate 400 (Neutral)
  if (signal === SignalType.BUY) color = '#10b981'; // Emerald 500
  if (signal === SignalType.SELL) color = '#f43f5e'; // Rose 500
  if (signal === SignalType.NEUTRAL) color = '#3b82f6'; // Blue 500

  const data = [
    { name: 'Confidence', value: confidence },
    { name: 'Remaining', value: 100 - confidence },
  ];

  const cx = "50%";
  const cy = "70%";
  const iR = 60;
  const oR = 80;

  // Needle rotation calculation (-90 to 90 degrees typically for semi-circle, but here we do full circle or partial)
  // Let's do a simple donut for clean UI
  
  return (
    <div className="flex flex-col items-center justify-center p-4 bg-slate-800/50 rounded-xl border border-slate-700 h-full min-h-[200px]">
      <h3 className="text-sm uppercase tracking-wider text-slate-400 mb-2">Signal Strength</h3>
      <div className="h-40 w-full relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx={cx}
              cy={cy}
              startAngle={180}
              endAngle={0}
              innerRadius={iR}
              outerRadius={oR}
              paddingAngle={5}
              dataKey="value"
              stroke="none"
            >
              <Cell key="cell-0" fill={color} />
              <Cell key="cell-1" fill="#1e293b" /> {/* Slate 800 background for empty part */}
            </Pie>
            <Tooltip 
                contentStyle={{ backgroundColor: '#0f172a', borderColor: '#334155', color: '#f1f5f9' }}
                itemStyle={{ color: '#f1f5f9' }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-6 pointer-events-none">
            <span className="text-3xl font-bold" style={{ color }}>{confidence}%</span>
            <span className="text-xs text-slate-400 mt-1">{signal}</span>
        </div>
      </div>
    </div>
  );
};

export default SignalGauge;
